module.exports = __webpack_public_path__ + "img/plus.52566156.svg";